/* ------------------------------------------------------------------------ */
/*		File: cmpPlan.tsx                                               */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICmpPlan } from "./cmpPlan.d";
import { getImage } from "../../components/GenericComponents/functions";
import "./cmpPlan.css";

const Plan: React.FC<ICmpPlan> = (props) => {
    return (
        <div className="card_plan_container">
            <div className={`card_plan ${props.isPopular ? "popular" : ""}`}>
                <div className="card_plan_one">
                    <div className="card_plan_one_label">{props.label}</div>
                    <div className="card_plan_one_price">{props.price}</div>
                </div> 
                <div className="card_plan_line" />
                <div className="card_plan_options">
                    {props.options?.map((item, index) => (
                        <div key={index} className="card_plan_options_option">
                            {/* <div className="card_plan_options_option bullet"> */}
                                <img src={getImage("check.svg")} alt={"check.svg"} />
                            {/* </div> */}
                            <div className="card_plan_options_option text">{item.total} {item.label}</div>
                        </div>
                    ))}
                </div>
                {props.hasFreeClasses && (
                    <div className="card_plan_freeclass">
                        <div className="card_plan_freeclass_total">{props.freeClasses?.total}</div>
                        <div className="card_plan_freeclass_label">{props.freeClasses?.label}</div>
                    </div>
                )}
            </div>
            {props.isPopular && (
                <div className="isPopular">
                    Popular Plan
                </div>
            )}
        </div>
    );
};

export default Plan;
